import { getBoApiBasePath } from 'apps/core/utils/services';
import { GET, POST, DELETE, PUT } from 'service/REST';
import type {
  TemplateResponse,
  FetchTemplatesParameters,
  FetchTemplateHistoryParameters,
  TemplateHistoryResponse,
  CreateTemplateParameters,
  CreateUpdateTemplateResponse,
  UpdateTemplateParameters,
  DeleteTemplateParameters,
} from 'apps/shared/data-access/types/templates';

export const fetchTemplates = async <T = TemplateResponse>(
  parameters: FetchTemplatesParameters,
): Promise<T> => {
  const { type, merchantId } = parameters;
  const response = await GET(
    getBoApiBasePath(`/template/${type}/read?merchantId=${merchantId}&start=0&limit=50`),
  );

  return response.json() as Promise<T>;
};

export const fetchTemplateHistory = async <T = TemplateHistoryResponse>(
  parameters: FetchTemplateHistoryParameters,
): Promise<T> => {
  const { templateType, merchantId, limit = '30' } = parameters;
  const response = await GET(
    getBoApiBasePath(`/template/html/history/${templateType}?limit=${limit}&merchantId=${merchantId}`),
  );

  return response.json() as Promise<T>;
};

export const createTemplate = async <T = CreateUpdateTemplateResponse>(
  parameters: CreateTemplateParameters,
): Promise<T> => {
  const { merchantId, payload } = parameters;
  const response = await POST(getBoApiBasePath(`/template/?merchantId=${merchantId}`), payload);

  return response.json() as Promise<T>;
};

export const updateTemplate = async <T = CreateUpdateTemplateResponse>(
  parameters: UpdateTemplateParameters,
): Promise<T> => {
  const { merchantId, payload } = parameters;
  const response = await PUT(getBoApiBasePath(`/template/${payload.id}/?merchantId=${merchantId}`), payload);

  return response.json() as Promise<T>;
};

export const deleteTemplate = async <T = TemplateResponse>(
  parameters: DeleteTemplateParameters,
): Promise<T> => {
  const { merchantId, templateId } = parameters;
  const response = await DELETE(getBoApiBasePath(`/template/${templateId}?merchantId=${merchantId}`));

  return response.json() as Promise<T>;
};
